import * as PROJECT_CODE from '../../../constants/projectCode';
import { UnityCategory } from './UnityCategory';
import { UnityUnit } from './UnityUnit';
import { UnityRoom } from './UnityRoom';
import { UnityUpgradeSelection } from './UnityUpgradeSelection';
import { UnityUpgradeOption } from './UnityUpgradeOption';
import { Carousel } from 'react-responsive-carousel';
import React, { useState } from 'react';
import './UnityPopulateMenus.css';
import {Collapse} from 'react-collapse';
import { floor } from 'lodash';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { IconButton } from '@material-ui/core';
//When unity loads up it will send us all of our categories to see

export function PopulateCategories(_data){
    //allCategories
    console.log(" What is wrong with my data " , _data);
    var allCategories = _data;

    if(allCategories[0] === ""){
        allCategories.shift();
    }

    return(
        <Carousel
            autoPlay={false}
            showArrows={true}
            renderIndicator={false}
            centerMode={true}
            swipeable={false}
            showStatus={false}
            emulateTouch={true}
            infiniteLoop={false}
            showIndicators={true}
            showThumbs={true}
        >
        {
            allCategories.map((category)=>{
                console.log("Show ", category);
                return(<div>
                
                    {UnityCategory(category)}
                
                </div>);
            })
        }
        </Carousel>
        
    )
}
//Make Integration Test

//When we select a category we will ask unity for all the units information
export function PopulateUnits(_data, floorPlanInfo){
    //populateUnits

    var allUnits = Object.values(_data);


    return(
        <>
            <Carousel
                autoPlay={false}
                showArrows={true}
                renderIndicator={false}
                centerMode={true}
                swipeable={false}
                showStatus={false}
                emulateTouch={true}
                infiniteLoop={false}
                showIndicators={true}
                showThumbs={true}
            >
                {allUnits.map((unit)=>{
                    return(<div>{UnityUnit(unit, floorPlanInfo)}</div>)
                })}
            </Carousel>
        </>
    )

}
//Make Integration Test


//When we first enter a lot or we hit back from Upgrade Selections
//json data will be used to populate lots
var ListOfFloorsToClose = {};

const closeAllFloorsExceptThis = (thisFloorKey) =>{

    console.log("CLEAR ALL FLOORS EXCEPT " + thisFloorKey)

    var allFloorKeys = Object.keys(ListOfFloorsToClose);

    var counter;

    //console.log("all floor keys ", allFloorKeys);


    for(counter = 0; counter < allFloorKeys.length; counter++){
        if(allFloorKeys[counter] !== thisFloorKey){
            var tempClose = ListOfFloorsToClose[allFloorKeys[counter]];
            console.log("CLEARING " + allFloorKeys[counter]);
            tempClose();
        }
    }
}

export function PopulateRooms(_data){
    //populateRooms

    var allFloors = _data;

    var allFloorKeys = Object.keys(allFloors);

    ListOfFloorsToClose = {};

    return(
        <div className="unit_floors_div">
            
            {allFloorKeys.map((floorKey)=>{
                return(
                <>
                    <IndividualFloor 
                        _allFloors={allFloors}
                        _floorKey={floorKey}
                    />
                </>
                )
            })}
            
        </div>
    )
    
}

export function IndividualFloor (props){

    const [openState, setOpenState] = useState(false);

    const changeStateExpand = () =>{
        closeAllFloorsExceptThis(props._floorKey);
        if(openState === true){
            setOpenState(false);
        }
        else{
            setOpenState(true);
        }
    }

    const closeStateExpanded = () =>{
        setOpenState(false);
    }

    
    ListOfFloorsToClose[props._floorKey] = () =>{closeStateExpanded();};
    

    console.log("This floor key " , props._floorKey + " all floors " , props._allFloors);
    //<button onClick={()=>{changeStateExpand();}}>Expand</button>
    return(
        <div>
            <div className="unit_floors_expand_div">
                <h1>{props._floorKey}</h1>
                <div className="unit_floors_expand_icon_div">
                    <IconButton onClick={()=>{changeStateExpand();}}>
                        <ArrowDropDownIcon/>
                    </IconButton>
                </div>
            </div>
            <Collapse isOpened={openState}>
                <Carousel
                    autoPlay={false}
                    showArrows={true}
                    renderIndicator={false}
                    centerMode={false}
                    swipeable={false}
                    showStatus={false}
                    emulateTouch={true}
                    infiniteLoop={false}
                    showIndicators={true}
                    showThumbs={true}
                >
                    {
                        props._allFloors[props._floorKey].map((room)=>{
                            return(<>{UnityRoom(room)}</>)
                        })
                    }
                </Carousel>
            </Collapse>
        </div>
    )
}
//Make Integration Test

//Once you have selected your type of upgrade at this we populate the upogrades
// This needs to be an onclick for 
export function PopulateUpgradeOptions(_data){
    //upgradeList

    var upgradeOptions = _data.upgradeList;

    console.log("PopulateUpgradeOptions " , upgradeOptions);

    return(
        upgradeOptions.map((upgradeOption)=>{
            return(<>
            
                {UnityUpgradeOption(upgradeOption)}
            
            </>);
        })
    )
}
//Make Integration Test

//When unity has moved to a new room a json will be sent to populate
// the upgrades inside that room
export function PopulateUpgradeSelections(_data){
    //currentUpgrades

    
    var selectedUpgrades = _data;

    console.log("This is the data for upgrade options ", selectedUpgrades);
    return(
        selectedUpgrades.map((upgrades)=>{
            return(<>
            
                <UnityUpgradeSelection/>
            
            </>);
        })
    )
}
//Make Integration Test







